module.exports = __webpack_public_path__ + "img/special-offer.2103fa99.webp";